import _slicedToArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { io } from 'socket.io-client';
export var SOCKET_EVENTS = {
  connect: 'connect',
  disconnect: 'disconnect',
  heartbeat: 'heartbeat',
  sendMessage: 'send_message',
  message: 'new_message',
  reconnect: 'reconnect',
  error: 'connect_error',
  agentMessage: 'agent_message',
  agentNotification: 'agent_notification'
};
var DEFAULT_HEARTBEAT_INTERVAL_MS = 30000;
var socketInstance = null;
var heartbeatTimer = null;
var isManualDisconnecting = false;
var socketDisconnectHandlerSet = new Set();

var emitSocketDisconnect = function emitSocketDisconnect(reason) {
  socketDisconnectHandlerSet.forEach(function (handler) {
    handler(reason);
  });
};

var toSocketQuery = function toSocketQuery() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var token = arguments.length > 1 ? arguments[1] : undefined;

  var merged = _objectSpread(_objectSpread({}, query), {}, {
    token: token
  });

  return Object.entries(merged).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (value === undefined || value === null) {
      return acc;
    }

    acc[key] = String(value);
    return acc;
  }, {});
};

var clearHeartbeat = function clearHeartbeat() {
  if (!heartbeatTimer) {
    return;
  }

  clearInterval(heartbeatTimer);
  heartbeatTimer = null;
};

var startHeartbeat = function startHeartbeat() {
  var intervalMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_HEARTBEAT_INTERVAL_MS;
  clearHeartbeat();
  heartbeatTimer = setInterval(function () {
    var _socketInstance;

    if (!((_socketInstance = socketInstance) !== null && _socketInstance !== void 0 && _socketInstance.connected)) {
      return;
    }

    socketInstance.emit(SOCKET_EVENTS.heartbeat, {
      timestamp: Date.now()
    });
  }, intervalMs);
};

var bindSocketEvent = function bindSocketEvent(event, handler) {
  if (!socketInstance) {
    return function () {
      return undefined;
    };
  }

  socketInstance.on(event, handler);
  return function () {
    var _socketInstance2;

    (_socketInstance2 = socketInstance) === null || _socketInstance2 === void 0 ? void 0 : _socketInstance2.off(event, handler);
  };
};

export var connectSocket = function connectSocket(options) {
  if (false) {
    return null;
  }

  if (socketInstance) {
    if (!socketInstance.connected) {
      socketInstance.connect();
    }

    return socketInstance;
  }

  var url = options.url,
      path = options.path,
      auth = options.auth,
      token = options.token,
      query = options.query,
      _options$heartbeatInt = options.heartbeatIntervalMs,
      heartbeatIntervalMs = _options$heartbeatInt === void 0 ? DEFAULT_HEARTBEAT_INTERVAL_MS : _options$heartbeatInt,
      _options$reconnection = options.reconnectionAttempts,
      reconnectionAttempts = _options$reconnection === void 0 ? Infinity : _options$reconnection,
      _options$reconnection2 = options.reconnectionDelay,
      reconnectionDelay = _options$reconnection2 === void 0 ? 1000 : _options$reconnection2,
      _options$reconnection3 = options.reconnectionDelayMax,
      reconnectionDelayMax = _options$reconnection3 === void 0 ? 5000 : _options$reconnection3,
      _options$timeout = options.timeout,
      timeout = _options$timeout === void 0 ? 20000 : _options$timeout;

  if (!url) {
    return null;
  }

  socketInstance = io(url, {
    path: path,
    auth: auth,
    autoConnect: false,
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: reconnectionAttempts,
    reconnectionDelay: reconnectionDelay,
    reconnectionDelayMax: reconnectionDelayMax,
    timeout: timeout,
    query: toSocketQuery(query, token)
  });
  socketInstance.on('connect', function () {
    startHeartbeat(heartbeatIntervalMs);
  });
  socketInstance.on('disconnect', function (reason) {
    clearHeartbeat();

    if (isManualDisconnecting) {
      isManualDisconnecting = false;
      return;
    }

    emitSocketDisconnect(reason);
  });
  socketInstance.connect();
  return socketInstance;
};
export var getSocket = function getSocket() {
  return socketInstance;
};
export var isSocketConnected = function isSocketConnected() {
  var _socketInstance3;

  return Boolean((_socketInstance3 = socketInstance) === null || _socketInstance3 === void 0 ? void 0 : _socketInstance3.connected);
};
export var disconnectSocket = function disconnectSocket() {
  clearHeartbeat();

  if (!socketInstance) {
    return;
  }

  if (isManualDisconnecting) {
    return;
  }

  if (!socketInstance.connected) {
    socketInstance.removeAllListeners();
    socketInstance = null;
    isManualDisconnecting = false;
    return;
  }

  isManualDisconnecting = true;
  emitSocketDisconnect('io client disconnect');
  socketInstance.disconnect();
  socketInstance.removeAllListeners();
  socketInstance = null;
  isManualDisconnecting = false;
};
export var sendSocketMessage = function sendSocketMessage(payload) {
  var _socketInstance4;

  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SOCKET_EVENTS.sendMessage;

  if (!((_socketInstance4 = socketInstance) !== null && _socketInstance4 !== void 0 && _socketInstance4.connected)) {
    return false;
  }

  socketInstance.emit(event, payload);
  return true;
};
export var onSocketMessage = function onSocketMessage(handler) {
  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SOCKET_EVENTS.message;
  return bindSocketEvent(event, handler);
};
export var onSocketConnect = function onSocketConnect(handler) {
  return bindSocketEvent(SOCKET_EVENTS.connect, handler);
};
export var onSocketDisconnect = function onSocketDisconnect(handler) {
  socketDisconnectHandlerSet.add(handler);
  return function () {
    socketDisconnectHandlerSet["delete"](handler);
  };
};
export var onSocketReconnect = function onSocketReconnect(handler) {
  return bindSocketEvent(SOCKET_EVENTS.reconnect, handler);
};
export var onSocketAgentNotification = function onSocketAgentNotification(handler) {
  return bindSocketEvent(SOCKET_EVENTS.agentNotification, handler);
};
export var onSocketError = function onSocketError(handler) {
  return bindSocketEvent(SOCKET_EVENTS.error, handler);
};